import { ArrowUp } from "lucide-react";
import { AnimatePresence, type Transition, motion, useReducedMotion } from "motion/react";
import { useTranslation } from "react-i18next";

const pillTransition: Transition = { type: "spring", bounce: 0, duration: 0.3 };

const reducedMotionTransition: Transition = { duration: 0.15 };

type NewNotificationsPillProps = {
  count: number;
  onClick: () => void;
};

export function NewNotificationsPill({ count, onClick }: NewNotificationsPillProps) {
  const { t } = useTranslation();
  const prefersReducedMotion = useReducedMotion();
  const hidden = prefersReducedMotion ? { opacity: 0 } : { opacity: 0, y: -12 };
  const label = t("notifications.newCount", { count });

  return (
    <>
      <span className="sr-only" aria-live="polite">
        {count > 0 ? label : ""}
      </span>
      <AnimatePresence>
        {count > 0 && (
          <motion.button
            type="button"
            initial={hidden}
            animate={{ opacity: 1, y: 0 }}
            exit={hidden}
            transition={prefersReducedMotion ? reducedMotionTransition : pillTransition}
            onClick={onClick}
            className="absolute top-2 left-1/2 z-20 flex -translate-x-1/2 items-center gap-1.5 rounded-full bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            <ArrowUp className="size-3" aria-hidden="true" />
            {label}
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}
